import { Button, Typography } from '@/ui';

import type { PeerInsightsEntry } from './types';

interface PeerInsightsRowProps {
  entry: PeerInsightsEntry;
  onViewClick?: (entry: PeerInsightsEntry) => void;
  viewLabel: string;
}

const PeerInsightsRow = ({
  entry,
  onViewClick,
  viewLabel,
}: PeerInsightsRowProps) => {
  const isAwaitingResponse = entry.awaitingResponse === true;
  const actionLabel =
    entry.actionLabel ?? (isAwaitingResponse ? 'Awaiting response' : viewLabel);
  const respondedLabel = `${entry.respondedCount}/${entry.totalParticipants} peers responded`;

  return (
    <div className="flex items-center justify-between gap-4 py-3">
      <div className="space-y-1">
        <Typography className="text-cement-500" variant="subtitle2">
          {entry.dateLabel}
        </Typography>
        {!isAwaitingResponse && (
          <Typography className="text-cement-400" variant="caption">
            {respondedLabel}
          </Typography>
        )}
      </div>

      <Button
        className="min-w-20"
        color="primary"
        disabled={isAwaitingResponse}
        size="small"
        variant="contained"
        onClick={isAwaitingResponse ? undefined : () => onViewClick?.(entry)}
      >
        {actionLabel}
      </Button>
    </div>
  );
};

export default PeerInsightsRow;
